.link {
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  cursor: pointer;
  transition: color var(--nexus-transition-fast), text-shadow var(--nexus-transition-fast);
  text-decoration: none;
  border-radius: var(--nexus-radius-sm);
}

.link:hover {
  text-decoration: none;
}

.link:focus-visible {
  outline: 2px solid var(--nexus-border-focus);
  outline-offset: 2px;
}

/* Variants */

.primary {
  color: var(--nexus-primary);
}

.primary:hover {
  color: var(--nexus-primary-hover);
  text-shadow: 0 0 12px color-mix(in srgb, var(--nexus-primary) 40%, transparent);
}

.primary:active {
  color: var(--nexus-primary-active);
  text-shadow: none;
}

.muted {
  color: var(--nexus-text-muted);
}

.muted:hover {
  color: var(--nexus-text-secondary);
  text-shadow: 0 0 10px color-mix(in srgb, var(--nexus-text-muted) 35%, transparent);
}

.muted:active {
  color: var(--nexus-text);
  text-shadow: none;
}

.inherit {
  color: inherit;
}

.inherit:hover {
  opacity: 0.8;
  text-shadow: 0 0 8px color-mix(in srgb, currentColor 30%, transparent);
}

.inherit:active {
  opacity: 0.7;
  text-shadow: none;
}
